import { render } from "./NewFinanceCard.vue?vue&type=template&id=f60875ac"
import script from "./NewFinanceCard.vue?vue&type=script&lang=js"
export * from "./NewFinanceCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__